import post from '../postService'
import URL from '../../Constants/apiUrls'

export default async function resolveMR(reqData) {
  try {
    const res = await post(`${URL.resolveMaintenanceRequest}`, reqData)
    return res.data
  } catch (error) {
    return error
  }
}
